import { createReducer } from 'redux-create-reducer'
import {
  CONFIRM_BOOKING_INIT,
  CONFIRM_BOOKING_SUCCESS,
  CONFIRM_BOOKING_FAILED,
  MESSAGE_BOX_TOGGLE,
  F_PAYMENT_METHOD,
  PAYMENT_CARD,
  SAVE_PROMO_CODE_SUCCESS,
  DELETE_PROMO_CODE_SUCCESS,
  F_SEND_EMAILS,
} from '../constants'
import { yourDataBlock } from '../helpers/drupalSettings'

const initialState = {
  values: {
    [F_PAYMENT_METHOD]: PAYMENT_CARD,
    [F_SEND_EMAILS]: false,
    ...Object.fromEntries(Object.entries(yourDataBlock?.blockForm?.fields ?? {}).map(([key, initValue]) => [key, initValue.value])),
  },
  submitErrors: {
    message: null,
    field: null,
    showAgreementMessageBox: null,
  },
  isStarted: false,
  isFinished: false,
  promoCode: null,
}

export default createReducer(initialState, {
  [CONFIRM_BOOKING_INIT](state) {
    return {
      ...state,
      isStarted: true,
      isFinished: false,
      submitErrors: {
        ...state.submitErrors,
        message: initialState.submitErrors.message,
        field: initialState.submitErrors.field,
      },
    }
  },
  [CONFIRM_BOOKING_SUCCESS](state) {
    return {
      ...state,
      submitErrors: {
        ...initialState.submitErrors,
        showAgreementMessageBox: false,
      },
      isStarted: false,
      isFinished: true,
    }
  },
  [CONFIRM_BOOKING_FAILED](state, { submitErrors }) {
    return {
      ...state,
      submitErrors,
      isStarted: false,
      isFinished: true,
    }
  },
  [MESSAGE_BOX_TOGGLE](state, { field }) {
    return {
      ...state,
      submitErrors: {
        ...initialState.submitErrors,
        [field]: false,
      },
    }
  },
  [SAVE_PROMO_CODE_SUCCESS](state, { promoCode }) {
    return {
      ...state,
      promoCode,
    }
  },
  [DELETE_PROMO_CODE_SUCCESS](state) {
    return {
      ...state,
      promoCode: null,
    }
  },
})
